import { push } from 'connected-react-router';

import { generatePath } from 'utils/generatePath';
import { closeModal } from 'base/actions/modal';

import { MENU } from 'menus/constants/entities';
import { CART } from 'cart/constants/entities';
import { CART_BASE } from 'cart/constants/paths';

export const closeEditCartForm = previousLocation => (dispatch, getState) => {
  const { cart } = getState();
  const id = cart.online_ordering_location;

  /** close cart on / or /cart.
   * / refers to when user open through modal
   * /cart refers to when user open through route
   */
  if (previousLocation === CART_BASE) {
    dispatch(push(generatePath(CART, 'cart')));
  } else {
    dispatch(closeModal());
    dispatch(push(generatePath(MENU, 'menu', { id })));
  }
};
